<div #resizeContainer id="resize-container" [class]="orientation">
    <div #panelFirst id="panel-first" class="flex" [style.userSelect]="isResizing ? 'none' : 'auto'" [style.flex-basis]="panelFirstSize">
        <slot name="left"></slot>
        <slot name="top"></slot>
    </div>
    <div #resizeHandleHorizontal class="resize-handle resize-handle-horizontal" (mousedown)="resize($event)" *ngIf="orientation === 'horizontal'">
        <span class="resize-handle-icon-vertical"></span>
    </div>
    <div #resizeHandleVertical class="resize-handle resize-handle-vertical" (mousedown)="resize($event)" *ngIf="orientation === 'vertical'">
        <hr class="resize-handle-icon-horizontal" />
    </div>
    <div #panelLast id="panel-last" [style.userSelect]="isResizing ? 'none' : 'auto'" [style.flex-basis]="panelLastSize">
        <slot name="right"></slot>
        <slot name="bottom"></slot>
    </div>
</div>
